import React from 'react'

let bannerHeader = ''

try {
  bannerHeader = require('@loyal/images/banner-header.png')
} catch (e) {}

const SliderCustomContainer = () => {
  return (
    <div className='container-slider pt-1 w-100'>
      <div className='pos-relative radius px-0'>
        <div className='row align-items-center h-100'>
          <div className='banner-information col-12 mb-4 mb-md-0 px-3 px-md-1'>
            <div className='row'>
              <div className='col-12'>
                <h2>
                  {process.env.REACT_APP_SLIDER_CUSTOM_TEXT}
                </h2>
              </div>
            </div>
          </div>
          <div className='banner-illustration col-12'>
            <img src={bannerHeader} alt='Com PicPau é mais fácil pagar e também ganhar!' className='w-100' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SliderCustomContainer



// WEBPACK FOOTER //
// ./src/features/Slider/SliderCustomContainer.js